export default __webpack_public_path__ + "static/media/11.ff518826.png";